import { render, staticRenderFns } from "./Unidade.vue?vue&type=template&id=486d3ecb&"
import script from "./Unidade.vue?vue&type=script&lang=js&"
export * from "./Unidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports